<template>
  <v-dialog max-width="600" v-model="dialog">
    <v-card>
      <v-card-title>
        <h4>{{ $t('correspondentieBeheer.brieven.delete.title') }}</h4>
        <v-spacer/>
        <v-icon @click="handleCancel">close</v-icon>
      </v-card-title>

      <v-card-text class="mt-8">
        {{ $t('correspondentieBeheer.brieven.delete.content') }}
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click="handleCancel">
          {{ $t('correspondentieBeheer.brieven.delete.actions.no') }}
        </v-btn>
        <v-btn color="error" @click="handleSubmit">
          {{ $t('correspondentieBeheer.brieven.delete.actions.yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  name: "confirmDeleteTemplate",
  props: {
    value: false
  },
  data() {
    return {
      dialog: this.value
    }
  },
  methods: {
    handleCancel: function () {
      this.$emit('input', false)
    },
    handleSubmit: function () {
      this.$emit('submit')
    }
  },
  watch: {
    value: function () {
      this.dialog = this.value;
    },
    dialog: function () {
      if (!this.dialog) {
        this.handleCancel();
      }
    }
  }
}
</script>

<style scoped>

</style>